<template>
	<div>
		<v-card-text class="py-0">
			<v-btn size="36" variant="text" icon @click="toggleExpansion" class="ml-0">
				<v-icon>
					mdi-play {{ expansion ? "mdi-rotate-90" : "" }}
				</v-icon>
			</v-btn>
			<span>{{ getTitle() }}</span>
		</v-card-text>
		<v-expand-transition>
			<div v-show="expansion" class="mx-3 mb-3">
				<v-card-text v-if="objects.length == 0" class="pa-0 pl-10">
					{{ $t("NO_DATA") }}
				</v-card-text>
				<object-group v-for="group in objectGroups" :key="group.terrain.getId()" :group=group
					@updateObject2DViewVisibility="updateObject2DViewVisibility" @updateGlobeVisibility="updateGlobeVisibility"
					@clear2DViews="clear2DViews" class="pa-0 ml-3">
				</object-group>
				<foundation-excavation-list-item v-for="foundationExcavation in foundationExcavations"
					:key="foundationExcavation.id" :foundationExcavationId="foundationExcavation.id" class="ml-3" />
			</div>
		</v-expand-transition>
	</div>
</template>

<script lang="ts">
import * as constants from "@/constant.js";
import objUpdateMixin from "@/mixins/objUpdateMixin.js";
import { type IObject, ObjectType } from "@/models/objects/types";
import { mapState } from "vuex";
import FoundationExcavationListItem from "./FoundationExcavation/FoundationExcavationListItem.vue";
import ObjectGroup from "./ObjectGroup.vue";

export default {
	mixins: [objUpdateMixin],
	components: {
		ObjectGroup,
		FoundationExcavationListItem,
	},
	props: {
		objId: String,
		// updateObjectListOfCreation: Boolean,
	},
	data() {
		return {
			expansion: false,
			objects2DViewVisibility: {},
		};
	},
	computed: {
		...mapState("object", ["objects"]),
		foundationExcavations(): IObject[] {
			return this.objects.filter(
				(o: IObject) => o.type === ObjectType.FOUNDATION_EXCAVATION,
			);
		},
		objectGroups() {
			const objectGroups = this.objects.reduce(
				(groups: Map<string, IObject[]>, object: IObject) => {
					const assetId = object.associatedTerrain.id;
					let group = groups.get(assetId.toString());
					if (!group) {
						group = [];
						groups.set(assetId.toString(), group);
					}
					group.push(object);
					return groups;
				},
				new Map<string, IObject[]>(),
			);
			return this.$store.getters.terrainList.reduce((groups, terrain) => {
				const objects = objectGroups.get(terrain.getAssetId()?.toString());
				if (objects) {
					groups.push({ terrain, objects });
				}
				return groups;
			}, []);
		},
	},
	watch: {
		objects(objs) {
			objs.forEach((obj) => {
				if (this.objects2DViewVisibility[obj.id] === undefined) {
					this.objects2DViewVisibility[obj.id] = false;
				}
			});
		},
	},
	methods: {
		getTitle() {
			return `${this.$t("OBJECT_DATA")}`;
		},
		toggleExpansion() {
			this.expansion = !this.expansion;
		},
		updateGlobeVisibility(visibility) {
			this.$emit("updateGlobeVisibility", visibility);
		},
		updateObject2DViewVisibility(show2DView, id) {
			if (!show2DView) {
				window["viewer"].clear2DViewes();
			}
			this.objects2DViewVisibility[id] = show2DView;
		},
		clear2DViews() {
			window["viewer"].clear2DViewes();
		},
	},
};
</script>